import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../provider/Auth.provider.jsx";
import { findUserByUID } from "../../../service/findUsers/findUserByUID.js";
import logout from "../../../service/logout.js";

// Components
import Header from "./Header.jsx";
import Edu from "./EduProg/Edu.js";
import Certificate from "./CertificatePage/CertificatePage.js";
import MyPackage from "./MyPackage/MyPackage.jsx";
import CourseDetails from "./MyPackage/CourseDetails/CourseDetails.jsx";
import Mymodule from "./MyPackage/Mymodule/Mymodule.jsx";
import VideoView from "./VideoView/VideoView.jsx";
import CourseList from "./CourseList/CourseList.jsx";
import CourseModules from "./CourseModules/CourseModules.jsx";
import PackageListView from "../../../components/LmsView/PackageListView.jsx";
import { Book, BookOpen, Award } from "lucide-react";
// Sidebar & Modals
import StudentRouting from "../../../components/FlowComponents/Sidebar/sidebarStudent.jsx";
import MobileSidebar from "../../../components/FlowComponents/MobileSidebar/MobileSidebar.jsx";
import UserNotification from "../../../components/FlowComponents/userNotification/UserNotification.jsx";
import UserProfile from "../../../components/FlowComponents/userProfile/UserProfile.jsx";
import { sampleNotificationData } from "../../../service/notificationService/sampleNotificationData.js";
import { useNavigate } from "react-router-dom";
// Assets
import edu from "./assets/edu.png";
import eduactive from "./assets/eduactive.png";
import cer from "./assets/cer.png";
import ceractive from "./assets/ceractive.png";
import { BookOpenText } from "lucide-react";
import Certificates from "./UserCertificate/Certificate";
import Transactions from "./Transactions/Transactions.jsx";
const Dashboard = () => {
  const { user } = useAuth();
  const location = useLocation();

  const [userData, setUserData] = useState({});
  const [activeElement, setActiveElement] = useState("education");

  const [notifyModal, setNotifyModal] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [isMobileSidebarVisible, setIsMobileSidebarVisible] = useState(false);
  const fetchUserData = async () => {
    const userData = await findUserByUID(user.uid);
    console.log(userData, "getting all about the user");
    setUserData(userData);
  };
  // Fetch user data
  useEffect(() => {
    fetchUserData();
  }, [user]);
  const navigate = useNavigate();

  useEffect(() => {
    if (activeElement === "education") {
      navigate("/student/dashboard");
    }
    if (activeElement === "package") {
      navigate("/student/dashboard");
    }
    if (activeElement === "certificate") {
      navigate("/student/dashboard");
    }
  }, [activeElement, navigate]);
  // Handle menu clicks
  const handleClick = (element) => {
    console.log(element, "geting el");
    // if (
    //   location.pathname.includes("/mypackage/course/") ||
    //   location.pathname.includes("/video/")
    // )
    // return;
    setActiveElement(element);
  };
  const menuItems = [
    {
      key: "education",
      label: "Education",
      icon: Book,
      activeIcon: BookOpenText,
    },
    {
      key: "myPackage",
      label: "My Package",
      icon: Book,
      activeIcon: BookOpenText,
    },
    {
      key: "package",
      label: "Browse Package",
      icon: Book,
      activeIcon: BookOpenText,
    },
    {
      key: "transaction",
      label: "Transactions",
      icon: Book,
      activeIcon: BookOpenText,
    },
    {
      key: "certificate",
      label: "Certificates",
      icon: Award,
      activeIcon: Award,
    },
  ];
  const [courseId, setCourseId] = useState("");

  return (
    <div className="flex h-screen">
      {/* New Sidebar */}
      <StudentRouting
        menuItems={menuItems}
        handleClick={handleClick}
        activeElement={activeElement}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <Header
          userData={userData}
          openNotifyModal={() => setNotifyModal(true)}
          openProfileModal={() => setProfileModal(true)}
          toggleMobileSidebar={() =>
            setIsMobileSidebarVisible(!isMobileSidebarVisible)
          }
        />
        <div className="flex-1 overflow-y-auto p-4">
          {location.pathname.includes("/video/") ? (
            <VideoView
              userData={userData}
              fetchUserData={fetchUserData}
              courseId={courseId}
            />
          ) : location.pathname.includes("/course/") &&
            location.pathname.includes("/modules") &&
            !location.pathname.includes("/mypackage/") ? (
            <CourseModules />
          ) : location.pathname.includes("/courses/") ? (
            <CourseList setCourseId={setCourseId} />
          ) : location.pathname.includes("/mypackage/course/") &&
            location.pathname.includes("/modules") ? (
            <Mymodule />
          ) : location.pathname.includes("/mypackage/course/") ? (
            <CourseDetails />
          ) : activeElement === "myPackage" ? (
            <MyPackage />
          ) : activeElement === "education" ? (
            <Edu />
          ) : activeElement === "certificate" ? (
            <Certificate userData={userData} />
          ) : activeElement === "package" ? (
            <PackageListView
              userData={userData}
              fetchUserData={fetchUserData}
            />
          ) : activeElement === "transaction" ? (
            <Transactions userData={userData} />
          ) : null}
        </div>
      </div>

      {/* Mobile Sidebar */}
      <MobileSidebar
        isVisible={isMobileSidebarVisible}
        onClose={() => setIsMobileSidebarVisible(false)}
        menuItems={menuItems}
        activeElement={activeElement}
        handleClick={handleClick}
      />

      {/* Notifications & Profile Modals */}
      <UserNotification
        showModal={notifyModal}
        closeModal={() => setNotifyModal(false)}
        sampleNotificationData={sampleNotificationData}
      />
      <UserProfile
        userData={userData}
        showModal={profileModal}
        closeModal={() => setProfileModal(false)}
      />
    </div>
  );
};

export default Dashboard;
